import { request } from './client';

export interface BalanceResponse {
  balance_ngonka: string; // bigint serialized
  balance_usd: number;
  gnk_usd_rate: number;
}

export const balanceApi = {
  get: () => request<BalanceResponse>('/api/balance'),
};
